export default __webpack_public_path__ + "BoxWarningFilled.svg?95e476e70edb712087c8a85653209a7a";